import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * SpeakableSchema Component
 * Critical for voice search and AI assistants (Siri, Alexa, Google Assistant)
 * Tells AI which parts of your page are suitable to be read aloud
 * 
 * IMPORTANT: Renders inline so Google can see it on first crawl
 */
const SpeakableSchema = ({ 
  name,
  description,
  url,
  speakableSections = [] // CSS selectors for speakable content
}) => {
  const { pathname } = useLocation();
  const path = pathname.replace(/\/+$/, '');
  const isHome = path === '';
  const speakableSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    ...(isHome ? { name, description } : {}),
    "speakable": {
      "@type": "SpeakableSpecification",
      "cssSelector": speakableSections.length > 0 
        ? speakableSections 
        : ["h1", "h2", ".hero-description", ".main-content p:first-of-type"]
    },
    "url": url || `https://audioandco.com${path || ''}`
  };

  return (
    <script
      type="application/ld+json"
      data-schema="speakable"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(speakableSchema) }}
    />
  );
};

export default SpeakableSchema;
